module.exports = __webpack_public_path__ + "static/media/map-preview.1a479368.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map-preview.png
// module id = 1603
// module chunks = 0